import styled from 'styled-components';

import { IconPremium } from '@components/icons/premium';
import { useScopedTranslate } from '@locale/translate';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export type BadgeSubscriptionSize = 'sm' | 'md';
export type BadgeSubscriptionTier = 'premium' | 'enterprise';

export type BadgeSubscriptionProps = {
  size?: BadgeSubscriptionSize;
  tier?: BadgeSubscriptionTier;
};

export const BadgeSubscription = ({ size = 'md', tier = 'premium' }: BadgeSubscriptionProps) => {
  const { t } = useScopedTranslate(locale);

  return (
    <Container $size={size}>
      {size === 'md' && (
        <IconWrapper>
          <IconPremium />
        </IconWrapper>
      )}
      {t(tier)}
    </Container>
  );
};

const SIZE_MAP: Record<BadgeSubscriptionSize, string> = {
  sm: pxToRem(16),
  md: pxToRem(24),
};

const PADDING_MAP: Record<BadgeSubscriptionSize, string> = {
  sm: `${pxToRem(2)} ${pxToRem(4)}`,
  md: `${pxToRem(4)} ${pxToRem(8)}`,
};

const FONT_MAP: Record<BadgeSubscriptionSize, string> = {
  sm: theme.font.semibold10,
  md: theme.font.semibold12,
};

const Container = styled.div<{ $size: BadgeSubscriptionSize }>((p) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: pxToRem(4),
  height: SIZE_MAP[p.$size],
  padding: PADDING_MAP[p.$size],
  borderRadius: pxToRem(16),
  font: FONT_MAP[p.$size],
  color: theme.color.elementIndigo100,
  background: theme.color.indigoTrans5,
  borderWidth: pxToRem(1),
  borderStyle: 'solid',
  borderColor: theme.color.elementIndigo100,
  boxSizing: 'border-box',
}));

const IconWrapper = styled.span({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: pxToRem(13),
  height: pxToRem(12),
  svg: {
    width: '100%',
    height: '100%',
  },
});

const locale = {
  en: {
    premium: 'Premium',
    enterprise: 'Enterprise',
  },
};
